import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SearchResultPostDto, SearchResultsPdfPostDto } from '@warema/shared/company-search/models';
import { SearchResultsPdfConnectorService } from '@warema/shared/connector-services';
import { Company } from '@warema/shared/models';
import { PrintTrackingService, SunCenterPrintingService } from '@warema/shared/services';
import { SnackbarType } from '@warema/warema-ui';
import { SnackbarService } from '@warema/warema-ui-angular';
import { first } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SunCenterSearchResultsService {
    private readonly _connectorService = inject(SearchResultsPdfConnectorService);
    private readonly _printingService = inject(SunCenterPrintingService);
    private readonly _translateService = inject(TranslateService);
    private readonly _printTrackingService = inject(PrintTrackingService);
    private readonly _snackbar = inject(SnackbarService);

    public printSearchResults(companies: Array<Company>, autocompleteAddress: string): void {
        this._printTrackingService.trackPrintSearchResults();
        const postDto: SearchResultsPdfPostDto = {
            language: this._translateService.getCurrentLang(),
            searchedAddress: autocompleteAddress.split(',')[0].trim(),
            searchedAddressCountry: autocompleteAddress.split(',')[1].trim(),
            searchResults: companies.map(x => this._companyToSearchResult(x)),
        };
        this._connectorService
            .getSearchResultsPdf(postDto)
            .pipe(first())
            .subscribe({
                next: pdf => {
                    this._printingService.print(pdf).catch((error: HttpErrorResponse) => {
                        void this._snackbar.showSnackbar({
                            type: SnackbarType.Error,
                            text: error.message,
                            duration: 300000,
                        });
                    });
                },
                error: (getError: HttpErrorResponse) => {
                    void this._snackbar.showSnackbar({
                        type: SnackbarType.Error,
                        text: getError.message,
                        duration: 300000,
                    });
                },
            });
    }

    private _companyToSearchResult(company: Company): SearchResultPostDto {
        return {
            companyAddressId: company.addressId,
            companyName: company.name,
            distance: company.distance,
            ratingCount: company.ratingCount,
            ratingStars: company.ratingStars,
            urlCityNameNo: company.businessCardUrl,
            streetAndNo: company.fullAddress.split(',')[0].trim(),
            postalCodeAndCity: company.fullAddress.split(',')[1].trim(),
            badges: company.badges,
        };
    }
}
